import React, { useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon, CheckCircleIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    title: 'Pressure Finally Stabilized',
    name: 'Alex P., 51',
    text: 'I used to get random BP spikes that made me nervous. After a few weeks on Cayenne+, my numbers have been steady—and I actually feel good again.'
  }, {
    name: 'James R., 58',
    title: 'Feeling in Fingers Returned',
    text: 'Three weeks and I can feel my fingers again after years of numbness. The tingling is gone completely.'
  }, {
    name: 'Patricia M., 65',
    title: 'Sleep Improved Dramatically',
    text: 'My cold feet were keeping me awake. Now I sleep like a baby and wake up refreshed for the first time in years.'
  }, {
    name: 'Frank D., 71',
    title: 'Doctor Was Amazed',
    text: 'My doctor was amazed. My circulation tests improved dramatically and he asked what I was doing differently.'
  }];
  const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = () => {
    setCurrentSlide(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
  };
  const goToSlide = index => {
    setCurrentSlide(index);
  };
  return <section className="py-8 md:py-12 border-b border-gray-200" data-id="element-207">
      <div className="bg-red-800 rounded-lg overflow-hidden" data-id="element-208">
        <div className="p-4 md:p-8 text-center" data-id="element-209">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 md:mb-8" data-id="element-210">
            40,000+ <br data-id="element-211" />
            Happy Customers
          </h2>
          <div className="relative" data-id="element-212">
            <div className="bg-white rounded-lg p-4 md:p-6 max-w-xl mx-auto" data-id="element-213">
              <h3 className="text-lg md:text-xl font-bold mb-2 flex justify-between" data-id="element-214">
                <span data-id="element-215">"{testimonials[currentSlide].title}"</span>
              </h3>
              <div className="flex text-yellow-400 mb-3 md:mb-4 justify-center" data-id="element-216">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-6 md:h-6 fill-current" data-id="element-217" />)}
              </div>
              <p className="text-sm md:text-lg text-gray-700 mb-4 md:mb-6" data-id="element-218">
                "{testimonials[currentSlide].text}"
              </p>
              <div className="flex justify-between items-center" data-id="element-219">
                <span className="font-medium text-sm md:text-lg" data-id="element-220">
                  {testimonials[currentSlide].name}
                </span>
                <div className="bg-red-800 rounded-full p-1" data-id="element-221">
                  <CheckCircleIcon className="w-4 h-4 md:w-6 md:h-6 text-white" data-id="element-222" />
                </div>
              </div>
            </div>
            <button onClick={prevSlide} className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-1/2 bg-white rounded-full p-1 md:p-2 shadow-lg" data-id="element-223">
              <ChevronLeftIcon className="w-4 h-4 md:w-6 md:h-6 text-red-800" data-id="element-224" />
            </button>
            <button onClick={nextSlide} className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-1/2 bg-white rounded-full p-1 md:p-2 shadow-lg" data-id="element-225">
              <ChevronRightIcon className="w-4 h-4 md:w-6 md:h-6 text-red-800" data-id="element-226" />
            </button>
          </div>
          <div className="flex justify-center mt-4 md:mt-6 space-x-2" data-id="element-227">
            {testimonials.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-2 h-2 md:w-3 md:h-3 rounded-full ${index === currentSlide ? 'bg-white' : 'bg-white/50'}`} data-id="element-228" />)}
          </div>
        </div>
      </div>
    </section>;
}